export const SITE = {
  name: "GPS Smart Labels",
  brand: "GoAndTrack",
  tagline: "Two smart-label architectures. One honest answer to where your goods are.",
  url: "https://gpssmartlabels.com",
  email: "info@goandtrack.com",
};

export const NAV = [
  { label: "GNTS1 Bluetooth", to: "/gnts1-bluetooth-smart-sticker" },
  { label: "LL100 4G", to: "/ll100-4g-smart-label" },
  { label: "Compare", to: "/compare-smart-labels" },
  { label: "How It Works", to: "/how-smart-labels-work" },
  { label: "Pilot", to: "/smart-label-pilot" },
  { label: "Platform", to: "/goandtrack-platform" },
  { label: "Use Cases", to: "/use-cases" },
  { label: "Insights", to: "/insights" },
  { label: "About", to: "/about" },
];

export const DEFAULT_META = {
  title: "GPS Smart Labels by GoAndTrack — Bluetooth & 4G Smart Labels",
  description:
    "Compare the GNTS1 Bluetooth smart sticker and the LL100 4G cellular smart label. Honest guidance, transparent location methods, and a guided pilot programme.",
};

export const SPEC_DISCLAIMER =
  "Specifications marked with an asterisk or shown in [brackets] are pending verification against final manufacturer datasheets. Reporting behaviour and battery life depend on configuration and deployment conditions. Always validate suitability for your application with GoAndTrack before purchase.";

export const PLACEHOLDER_NOTE =
  "Placeholder — awaiting approved figure or asset from GoAndTrack before publish.";

export const NETWORK_DISCLAIMER =
  "Detection availability and reporting frequency depend on the presence, configuration and connectivity of compatible participating devices. Network size does not guarantee detection at a particular location, on a particular route or at a fixed interval. Cellular-label performance similarly depends on coverage, configuration and operating conditions.";
